export const EModalName = {
  APPLICATION_REJECTION_REASONS: 'APPLICATION_REJECTION_REASONS',
  HIRE_CONFIRMATION: 'HIRE_CONFIRMATION',
};
